/**
 * Cross-tenant super-admin lead-move endpoints.
 *
 * The destination list is fetched with an explicit companyId. That scoping is
 * a server-side INNER JOIN on company_conferences — do not re-implement it on
 * the client, and do not call this without a company.
 */
import type { BatchMoveDestination, BatchMoveLeadsResult } from '@viq-admin/screens';
import { superadminFetch } from './dataProvider';

/**
 * GET /v1/superadmin/conferences?companyId=…&archived=false
 *
 * The handler wraps the row list as `{ conferences: [...] }` (see
 * apps/superadmin-console/src/handlers/conferences.ts), not a bare array.
 */
export async function listCompanyConferences(
  companyId: string,
): Promise<BatchMoveDestination[]> {
  const params = new URLSearchParams({ companyId, archived: 'false' });
  const body = await superadminFetch<{ conferences: BatchMoveDestination[] }>(
    `/v1/superadmin/conferences?${params.toString()}`,
  );
  return body.conferences;
}

/** POST /v1/superadmin/leads/move */
export async function moveLeads(
  leadIds: string[],
  destinationConferenceId: string,
): Promise<BatchMoveLeadsResult> {
  return superadminFetch<BatchMoveLeadsResult>('/v1/superadmin/leads/move', {
    method: 'POST',
    body: JSON.stringify({ leadIds, destinationConferenceId }),
  });
}
